export default function (t: number) {
  return t;
}
